/* Chheda's: keep the page still while the mobile menu is open.
   The theme only sets overflow:hidden on <body>, but this site scrolls on <html>,
   and iOS Safari ignores overflow:hidden for touch scrolling, so the page kept
   moving under the open menu. While the menu is open we:
   1. lock <html> as well as <body>, and
   2. cancel touch-drags that start outside the menu (iOS needs this).
   The page and the sticky header stay exactly where they were, and the menu
   itself can still scroll when it is taller than the screen. */
(() => {
  let locked = false;
  let menu = null;
  let startY = 0;
  let savedY = 0;
  let tapY = null;

  // The theme starts moving the page as soon as the menu icon is tapped, so
  // remember the position at the tap itself.
  document.addEventListener('pointerdown', event => {
    if (event.target.closest && event.target.closest('header-drawer summary, .menu-drawer-container > summary')) tapY = window.scrollY;
  }, true);

  function jumpTo(y) {
    const html = document.documentElement;
    const previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = previous;
  }

  function onTouchStart(event) {
    startY = event.touches[0] ? event.touches[0].clientY : 0;
  }

  function onTouchMove(event) {
    if (!locked) return;
    const scroller = menu && event.target.closest && event.target.closest('.menu-drawer__navigation-container, .menu-drawer');
    if (!scroller) { event.preventDefault(); return; }
    // Inside the menu: allow scrolling, but not past its top or bottom
    // (that would hand the scroll over to the page).
    const y = event.touches[0] ? event.touches[0].clientY : 0;
    const goingDown = y < startY;
    const atTop = scroller.scrollTop <= 0;
    const atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
    if ((atTop && !goingDown) || (atBottom && goingDown)) event.preventDefault();
  }

  function lock(details) {
    if (locked) return;
    locked = true;
    menu = details;
    // The menu lives in the header at the top of the page: show it there
    // straight away (the theme scrolls up anyway), and remember where the
    // shopper was so closing the menu puts them back.
    savedY = tapY !== null ? tapY : window.scrollY;
    tapY = null;
    jumpTo(0);
    document.documentElement.classList.add('chhedas-scroll-locked');
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    menu = null;
    document.documentElement.classList.remove('chhedas-scroll-locked');
    document.removeEventListener('touchstart', onTouchStart);
    document.removeEventListener('touchmove', onTouchMove);
    requestAnimationFrame(() => jumpTo(savedY));
  }

  function watch(details) {
    if (details.dataset.chhedasScrollLock) return;
    details.dataset.chhedasScrollLock = 'true';
    const sync = () => (details.hasAttribute('open') ? lock(details) : unlock());
    new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
    sync();
  }

  function init() {
    document.querySelectorAll('header-drawer details, .menu-drawer-container').forEach(watch);
  }

  init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', () => {
    if (!document.querySelector('header-drawer details[open], .menu-drawer-container[open]')) unlock();
  });
})();
